import React from "react"
import { Script } from "gatsby"

type Props = {
  url?: string
  width?: string
  height?: string
}

export const HatenaBookmark: React.FC<Props> = ({ url, width, height }) => {
  return (
    <>
      <a
        href={
          url
            ? `https://b.hatena.ne.jp/entry/${url}/`
            : "https://b.hatena.ne.jp/entry/"
        }
        className="hatena-bookmark-button"
        data-hatena-bookmark-layout="basic-counter"
        data-hatena-bookmark-width={width}
        data-hatena-bookmark-height={height}
        title="このエントリーをはてなブックマークに追加"
      >
        <img
          src="https://b.st-hatena.com/images/v4/public/entry-button/button-only@2x.png"
          alt="このエントリーをはてなブックマークに追加"
          width="20"
          height="20"
          style={{ border: "none" }}
        />
      </a>

      {/* Gatsby's Script component uses the value of src to deduplicate loading. */}
      <Script src="https://b.st-hatena.com/js/bookmark_button.js" />
    </>
  )
}
